import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect } from 'react';
import { Box } from '@hub/box';
import SearchInput from './search-input';
import QuitButton from './quit-button';
import ResultsPanel from './results-panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchForm = _ref => {
  let {
    refsAndCursor,
    autocomplete,
    placeholder,
    query,
    resetState,
    collections,
    context,
    onClickClose,
    reinitialiseQuery,
    setNonDebouncedQuery,
    backgroundColor
  } = _ref;
  const {
    autocompleteRefs,
    resetCursor
  } = refsAndCursor;
  useEffect(() => {
    autocomplete.refresh();
    // Honestly we only want to run this once, when the component first renders
    // We don't care if the dependency changes I promise.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const inputElement = refsAndCursor.autocompleteRefs.getElems().inputElement;
  const clearQuery = useCallback(() => {
    // But we still need to set the input value when the query is cleared
    resetState();
    resetCursor();
    setNonDebouncedQuery('');
    if (inputElement) {
      inputElement.value = '';
      inputElement.focus();
    }
  }, [inputElement, resetState, setNonDebouncedQuery, resetCursor]);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    sx: {
      background: backgroundColor,
      width: '100%',
      maxWidth: '520px',
      marginTop: 'spacing-md',
      marginLeft: ['spacing-none', 'spacing-none', 'spacing-3xl']
    }
  }, autocomplete.getRootProps(refsAndCursor.autocompleteRefs.getElems())), {}, {
    "data-id": "search-modal-autocomplete_search-form_SearchForm_Box",
    children: /*#__PURE__*/_jsx("form", _objectSpread(_objectSpread({
      ref: autocompleteRefs.formRef
    }, autocomplete.getFormProps(autocompleteRefs.getElems())), {}, {
      "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_form",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          marginX: ['spacing-xs', 'spacing-xs', 'spacing-none']
        },
        "data-id": "search-modal-autocomplete_search-form_SearchForm_form_Box",
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            width: '100%',
            display: ['block', 'block', 'none'],
            marginBottom: 'spacing-md',
            paddingX: 'spacing-md'
          },
          "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_Box_3",
          children: /*#__PURE__*/_jsx(QuitButton, {
            sx: {
              padding: 'spacing-none',
              float: 'right',
              background: 'transparent'
            },
            onClickClose: onClickClose,
            "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_QuitButton"
          })
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            paddingX: 'spacing-md'
          },
          "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_Box",
          children: /*#__PURE__*/_jsx(SearchInput, {
            onClickClose,
            refsAndCursor,
            autocomplete,
            placeholder,
            query,
            clearQuery,
            reinitialiseQuery,
            setNonDebouncedQuery,
            "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_SearchInput"
          })
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            paddingLeft: 'spacing-md'
          },
          "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_Box",
          children: /*#__PURE__*/_jsx(ResultsPanel, {
            backgroundColor,
            collections,
            context,
            refsAndCursor,
            autocomplete,
            query,
            "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_ResultsPanel"
          })
        })]
      })
    }))
  }));
};
export default SearchForm;